export type SeoConfig = Partial<{
  googleAnalyticsId: string;
  googleTagManagerId: string;
  googleSearchConsoleCode: string;
  microsoftClarityId: string;
  metaTitle: string;
  metaDescription: string;
  metaKeywords: string;
}>;

export const applySeoConfig = (config: SeoConfig) => {
  if (config.googleAnalyticsId) {
    window.GA_TRACKING_ID = config.googleAnalyticsId;
    (window as any).dataLayer = (window as any).dataLayer || [];
    window.gtag = window.gtag || function (...args: any[]) {
      (window as any).dataLayer.push(args);
    };
    window.gtag('js', new Date());
    window.gtag('config', config.googleAnalyticsId);
    let gaScript = document.getElementById('ga-script') as HTMLScriptElement | null;
    if (!gaScript) {
      gaScript = document.createElement('script');
      gaScript.id = 'ga-script';
      gaScript.async = true;
      document.head.appendChild(gaScript);
    }
    gaScript.setAttribute('src', `https://www.googletagmanager.com/gtag/js?id=${config.googleAnalyticsId}`);
  }

  if (config.googleTagManagerId) {
    window.GTM_ID = config.googleTagManagerId;
    const gtmNoscript = document.getElementById('gtm-noscript');
    if (gtmNoscript) {
      gtmNoscript.setAttribute('src', `https://www.googletagmanager.com/ns.html?id=${config.googleTagManagerId}`);
    }

    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    });

    const existingScript = document.getElementById('gtm-script-dynamic');
    if (existingScript) {
      existingScript.remove();
    }

    const gtmScript = document.createElement('script');
    gtmScript.id = 'gtm-script-dynamic';
    gtmScript.async = true;
    gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${config.googleTagManagerId}`;
    document.head.appendChild(gtmScript);
  }

  if (config.googleSearchConsoleCode) {
    const verification = document.getElementById('google-verification');
    if (verification) {
      verification.setAttribute('content', config.googleSearchConsoleCode);
    }
  }

  if (config.microsoftClarityId) {
    window.CLARITY_ID = config.microsoftClarityId;
    const oldScript = document.getElementById('clarity-script');
    if (oldScript) {
      oldScript.remove();
    }

    const clarityScript = document.createElement('script');
    clarityScript.id = 'clarity-script';
    clarityScript.type = 'text/javascript';
    clarityScript.text = `
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "${config.microsoftClarityId}");
    `;
    document.head.appendChild(clarityScript);
  }

  if (config.metaTitle) {
    document.title = config.metaTitle;
  }

  if (config.metaDescription) {
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', config.metaDescription);
    }
  }

  if (config.metaKeywords) {
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', config.metaKeywords);
    }
  }
};

declare global {
  interface Window {
    GA_TRACKING_ID?: string;
    GTM_ID?: string;
    CLARITY_ID?: string;
    gtag?: (...args: any[]) => void;
    clarity?: (...args: any[]) => void;
  }
}
